// @flow
import * as React from 'react';
import {
  searchFormBody as formBodyCls,
  searchOptionsContainer as optionsContainerCls,
  searchField as searchFieldCls,
  // searchQuickSearch as quickSearchCls,
  // searchQuickSearchLabel as quickSearchLabelCls,
  // searchQuickSearchButton as quickSearchButtonCls,
  searchDateSortOptions as dateSortOptionsCls,
  searchDateSortOptionsDateInput as dateInputCls,
  searchExtraOptionsToggle as extraOptionsToggleCls,
} from './SearchForm.scss';
import Field from './Field';
import Fieldset from './Fieldset';
import type { FieldConfig, FieldsetConfig } from './FieldConfig';
import { sortBy, startDate, endDate, catalog } from './config/fields.config';
import { Map } from 'immutable';
import classnames from 'classnames';

export type SearchFormValue = Map<string, *>;

const Button = (props: { [string]: * }) => {
  const { className: _className, disabled = undefined, ...rest } = props;
  const className = classnames(
    'ba b--black-025 mid-gray bg-moon-gray br1 brandon button-reset input-reset f4 lh-title ph3 pv2',
    {
      'o-50 not-allowed': disabled === true,
      'dim pointer': disabled !== true,
    },
    _className
  );

  return <button {...rest} disabled={disabled} className={className} />;
};

const renderFields = (
  valueMap: SearchFormValue,
  fields: Array<FieldConfig>,
  onChange: Function,
  fieldOverride?: { [string]: * } = {}
) =>
  fields.map(props => {
    const value = valueMap.get(props.name);
    const overrideProps = fieldOverride[props.name] || {};

    return (
      <Field
        key={props.name}
        {...props}
        {...overrideProps}
        value={value}
        onChange={onChange}
      />
    );
  });

export type FormProps = {
  onChange: SearchFormValue => void,
  onSubmit: SearchFormValue => void,
  value: SearchFormValue,
};

type Props = {
  onChange: SearchFormValue => void,
  onSubmit: SearchFormValue => void,
  onReset: () => void,
  primaryFieldsets: Array<FieldsetConfig>,
  extraFieldsets?: Array<FieldsetConfig>,
  fieldConfigOverrides?: { [string]: * },
  value: SearchFormValue,
  expanded: boolean,
  onExpand: () => void,
};

export type SearchFormProps = Props;
export default class SearchForm extends React.PureComponent<
  Props,
  {
    showExtraOptions: boolean,
  }
> {
  constructor(props: Props) {
    super(props);

    this.state = {
      showExtraOptions: false,
    };
  }

  toggleExtraOptions = () => {
    this.props.onExpand();
  };

  updateValues = ({ name, value: fieldValue }: { name: string, value: ?* }) => {
    const currentValue = this.props.value;
    const nextValue =
      fieldValue != null
        ? currentValue.set(name, fieldValue)
        : currentValue.remove(name);

    this.props.onChange(nextValue);
  };

  handleSubmit = (e: Event) => {
    e.preventDefault();
    this.props.onSubmit(this.props.value);
  };

  handleReset = () => {
    this.props.onReset();
  };

  render() {
    const {
      extraFieldsets,
      value,
      expanded: showExtraOptions,
      isUsingNewSearch,
    } = this.props;
    const startDateValue = value.get(startDate.name, startDate.defaultValue);
    const endDateValue = value.get(endDate.name, endDate.defaultValue);
    const sortByValue = value.get(sortBy.name, sortBy.defaultValue);
    const catalogValue = value.get(catalog.name, catalog.defaultValue);

    return (
      <form onSubmit={this.handleSubmit}>
        <div className={formBodyCls}>
          <section className={dateSortOptionsCls}>
            <div className={searchFieldCls}>
              <label htmlFor="">Date Range</label>
              <div
                className="flex flex-row justify-between"
                style={{ margin: '-0.5em 0' }}
              >
                <Field
                  {...startDate}
                  className={dateInputCls}
                  value={startDateValue}
                  onChange={this.updateValues}
                />
                <i
                  className="fa fa-long-arrow-right self-center"
                  aria-hidden="true"
                />
                <Field
                  {...endDate}
                  className={dateInputCls}
                  value={endDateValue}
                  onChange={this.updateValues}
                />
              </div>
            </div>
            {isUsingNewSearch ? (
              <Field
                {...catalog}
                value={catalogValue}
                onChange={this.updateValues}
              />
            ) : (
              <Field
                {...sortBy}
                value={sortByValue}
                onChange={this.updateValues}
              />
            )}
          </section>
          {/*
          <section className={quickSearchCls}>
            <span className={quickSearchLabelCls}>Quick Search</span>
            <button type="button" className={quickSearchButtonCls} disabled>
              Published
            </button>
            <button type="button" className={quickSearchButtonCls} disabled>
              Unpublished
            </button>
          </section>
          */}
          <div className={optionsContainerCls}>
            {this.props.primaryFieldsets.map(
              ({ legend, Icon, fields }, index) => (
                <Fieldset key={index} legend={legend} Icon={Icon}>
                  {renderFields(
                    this.props.value,
                    fields,
                    this.updateValues,
                    this.props.fieldConfigOverrides
                  )}
                </Fieldset>
              )
            )}
            {Array.isArray(extraFieldsets) && extraFieldsets.length ? (
              <div className="SearchForm--extra-fieldsets">
                {showExtraOptions === true &&
                  extraFieldsets.map(({ legend, fields, Icon }, index) => (
                    <Fieldset key={index} legend={legend} Icon={Icon}>
                      {renderFields(
                        this.props.value,
                        fields,
                        this.updateValues,
                        this.props.fieldConfigOverrides
                      )}
                    </Fieldset>
                  ))}
                <button
                  type="button"
                  onClick={this.toggleExtraOptions}
                  className={extraOptionsToggleCls}
                >
                  {showExtraOptions ? 'Hide Options' : 'More Options'}
                </button>
              </div>
            ) : (
              <br />
            )}
          </div>
        </div>
        <Button
          type="submit"
          className="Search__submitButton bg-blue white mt3 mr2"
        >
          Search
        </Button>
        <Button
          type="reset"
          className="Search__resetButton mt3"
          onClick={this.handleReset}
        >
          Clear
        </Button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/search/SearchForm/SearchForm.js